export function productStockQty(product) {
  const n = Number(product?.stock_qty ?? product?.stockQty);
  if (!Number.isFinite(n) || n < 0) return 0;
  return Math.floor(n);
}

export function isProductInStock(product) {
  return productStockQty(product) > 0;
}

/** Nhãn tồn kho cho khách / admin */
export function stockStatusLabel(qty) {
  const n = Number(qty) || 0;
  if (n <= 0) return 'Hết hàng';
  if (n <= 5) return `Còn ${n} — sắp hết`;
  return `Còn ${n}`;
}

export function stockStatusClass(qty) {
  const n = Number(qty) || 0;
  if (n <= 0) return 'stock-out';
  if (n <= 5) return 'stock-low';
  return 'stock-ok';
}
